import { Form, Select } from "antd";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import * as API from "@api";

export default function Project(props) {
  const [data, setData] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    API.Projects.getAll({ limit: 1000 }).then((res) => {
      if (res.error || !res) {
        return;
      }

      setData(res?.data?.rows || []);
    });
  };

  return (
    <Form.Item
      {...props}
      name="project_id"
      className="w-full"
      label={
        <span>
          Project{" "}
          <Link to="/projects/new" target="_blank">
            Add New
          </Link>
        </span>
      }
    >
      <Select
        placeholder="Select one"
        className="w-full"
        allowClear
        showSearch
        onClick={getData}
        filterOption={(input, option) =>
          option?.label?.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        filterSort={(optionA, optionB) =>
          (optionA?.label ?? "")
            .toLowerCase()
            .localeCompare((optionB?.label ?? "").toLowerCase())
        }
        options={data.map((val) => {
          return {
            label: val.name,
            value: val.id,
          };
        })}
      />
    </Form.Item>
  );
}
